<template>
  <div class="subscriptions">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Admin</h1>
          <h5 class="subtitle is-size-5">Active Subscriptions</h5>        
        </div>
      </div>
    </div>
    <div class="container">
      <br/>
      <p style="color: white;">
        <i class="fas fa-bullhorn"></i>&nbsp;&nbsp;
        <a style="color: white;" @click="$router.push('members')">Members</a>
      </p>
      <br/>
      <p style="color: white;">
        <i class="fas fa-bullhorn"></i>&nbsp;&nbsp;
        <a style="color: white;" @click="$router.push('messages')">Broadcast Messages (last 100)</a>
      </p>
      <br/>
      <p style="color: white;">
        <i class="fas fa-list-alt"></i>&nbsp;&nbsp;
        <a style="color: white;" @click="$router.push('bookings')">Bookings (Lane Setup)</a>
      </p>
      <br/>
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
              {{ errorMessage }}
          </div>
        </article>  
      </div>
      <div class="box">
        <div class="columns subscription-header">
          <div class="column">
            Email
          </div>
          <div class="column">
            Subscription Id
          </div>
          <div class="column">
            Options
            <span class="is-pulled-right subscription-icons"><i class="fas fa-plus-circle has-text-info" @click="addSubscription" title="ADD NEW SUBSCRIBER"></i></span>
          </div>
        </div>
        <div v-if="showAddNew">
          <div class="columns subscription">
            <div class="column">
              <input type="email" v-model="newSubscription.email" class="input is-primary" placeholder="email"/>
            </div>
            <div class="column">
              <input type="text" v-model="newSubscription.subscriptionId" class="input is-primary" placeholder="subscription id"/>
            </div>
            <div class="column subscription-icons">
              <button class="button is-primary" @click="saveNewSubscription" title="Save"><i class="fas fa-save"> Save</i></button>
              <button class="button is-danger" @click="cancelNewSubscription" title="Cancel"><i class="fas fa-times-circle"></i>Cancel</button>
            </div>
          </div>
        </div>
        <div v-for="(subscription,index) in subscriptions" :key="subscription._id">
          <div class="columns subscription">
            <div class="column">
              {{ subscription.email }}
            </div>
            <div class="column">
              {{ subscription.subscriptionId }}
            </div>
            <div class="column subscription-icons">
              <i class="fas fa-trash has-text-danger" v-on:click="deleteSubscription(subscription.subscriptionId, subscription.email, index)" title="DELETE"></i>
              <!--<i class="fas fa-edit has-text-warning" v-on:click="editSubscription" title="EDIT"></i>-->
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'admin',
    components : {
    },
    computed: {
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
            subscriptions: [],
            errorMessage: '',
            showError: false,
            pleaseWait: true,
            showAddNew: false,
            newSubscription: {
              email: '',
              subscriptionId: '',
              dateTimeStamp: new Date().toISOString()
            }
        }
    },
    methods:{
        addSubscription: function() {
          this.showAddNew = true;
        },
        saveNewSubscription: function() {

          var url = (this.debugMode ? "http://localhost:8080/subscribe" : "https://axes2api.azurewebsites.net/subscribe")

          var token = this.$parent.getApiToken();

          axios.post(url, 
            {
              email: this.newSubscription.email,
              subscriptionId: this.newSubscription.subscriptionId,
              dateTimeStamp: this.newSubscription.dateTimeStamp
            },
            {
              headers: {
                  authorization: token
                }
            }
          )
          .then((response) => {
            //console.log(response);
            alert("Subscription added.");      
            this.subscriptions.push(this.newSubscription);      
            this.newSubscription = { email: '', subscriptionId: ''};
            this.showAddNew = false;
          }, (error) => {
            alert("Error adding subscription to Axes2.");
            //console.log(error);
          });
        },
        cancelNewSubscription: function() {
          this.showAddNew = false;
          this.newSubscription = { email: '', subscriptionId: ''};
        },
        //editSubscription: function() {
        //  alert("not yet implemented");
        //},
        deleteSubscription: function(subscriptionId, email, index) {
          if (confirm('Delete subscription: ' + subscriptionId + '?')) {

            var url = (this.debugMode ? "http://localhost:8080/unsubscribe" : "https://axes2api.azurewebsites.net/unsubscribe")
            //console.log("unsubscribe " + subscriptionId);

            var token = this.$parent.getApiToken();

            //this really should be a DELETE request
            axios.post(url, {
                email: email,
                subscriptionId: subscriptionId
            },
            {
                headers: {
                  authorization: token
                }
            })
            .then((response) => {
              alert('Subscription Deleted.');
              //console.log(response);
              this.subscriptions.splice(index, 1);
            }, (error) => {
              alert("Error unsubscribing from Axes2.");
              //console.log(error);
            });
          }
        },
        getSubscriptions: function () {

          var url = (this.debugMode ? "http://localhost:8080/subscriptions" : "https://axes2api.azurewebsites.net/subscriptions")

          var token = this.$parent.getApiToken();

          axios.get(url,{
                headers: {
                    authorization: token
                }
            })
            .then((response) => {
              if (response.data.error != null) {
                this.errorMessage = response.data.error;
                this.showError = true;
                this.pleaseWait = false;
              } else {
                this.subscriptions = response.data; 
                this.pleaseWait = false;
              }
            }, (error) => {
              this.errorMessage = error;
              this.showError = true;
              this.pleaseWait = false;
            });
        },
        isAdmin() {
          return this.$parent.isAdmin();
        }
    },
    mounted(){
      //console.log("process.env.VUE_APP_DEBUG_MODE: " + process.env.VUE_APP_DEBUG_MODE);
      if (this.isAdmin()) {
        setTimeout(() => this.getSubscriptions(), 1000);
      } else {
        alert("You don't have permission to access this page.");
      }
    }
}
</script>

<style lang="scss" scoped>
  .hero {
    background-color: black;
  }
  .box {
    font-family: Verdana;
  }
  .subscription-header {
    background-color: black;
    color: white;
    font-size: 1.5em;
    border-radius: 6px;
  }
  .subscription {
    border-top: solid gray 1px;
    padding: 10px;
  }
  .subscription-icons {
    font-size: 1.5em;
  }
  .subscription-icons i {
    margin-right: 20px;
  }
  .blink {
    color: #97312d;
    animation: blink-animation 1s steps(5, start) infinite;
    -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
</style>